export const WwwPopsugarComExtractor = {
  domain: 'www.popsugar.com',

  title: {
    selectors: [
      'h2.post-title',
      'title-text',
    ],
  },

  author: {
    selectors: [
      ['meta[name="article:author"]', 'value'],
    ],
  },

  date_published: {
    selectors: [
      ['meta[name="article:published_time"]', 'value'],
    ],
  },

  lead_image_url: {
    selectors: [
        ['meta[name="og:image"]', 'value'],
    ],
  },

  content: {
    selectors: [
      '#content',
    ],

    // Is there anything in the content you selected that needs transformed
    // before it's consumable content? E.g., unusual lazy loaded images
    transforms: {
    },

    // Is there anything that is in the result that shouldn't be?
    // The clean selectors will remove anything that matches from
    // the result
    clean: [
      '.share-copy-title',
      '.post-tags',
      '.reactions',
    ],
  },
};
